import styled from "styled-components";

export const WrapperContent = styled.p`
  img,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: inline-block !important;
  }
  a{
    text-decoration: underline;
    color: blue;
  }
  ul{
    list-style: disc;
    margin-left: 15px;
  }
`;
